var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.544,
    height: 44.493,
    viewBox: "0 0 46.544 44.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Earn_Points",
    "data-name": "Earn Points",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M1009.5,877.5a4.322,4.322,0,0,0,1.356,3.035c1.761,1.821,5.018,3.035,8.762,3.035s7-1.214,8.762-3.035a4.323,4.323,0,0,0,1.356-3.035",
    transform: "translate(-1009.486 -853.218)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M1020.186,880.5a4.323,4.323,0,0,1-1.356,3.035",
    transform: "translate(-999.937 -850.147)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M1010.856,883.535a4.323,4.323,0,0,1-1.356-3.035",
    transform: "translate(-1009.486 -850.147)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M1009.5,871.5a4.323,4.323,0,0,0,1.356,3.035c1.761,1.821,5.018,3.035,8.762,3.035s7-1.214,8.762-3.035a4.323,4.323,0,0,0,1.356-3.035",
    transform: "translate(-1009.486 -859.359)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1081",
    "data-name": "Ellipse 1081",
    cx: 10.11,
    cy: 6.008,
    rx: 10.11,
    ry: 6.008,
    transform: "translate(0)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M1009.5,874.5a4.323,4.323,0,0,0,1.356,3.035c1.761,1.821,5.018,3.035,8.762,3.035s7-1.214,8.762-3.035a4.323,4.323,0,0,0,1.356-3.035",
    transform: "translate(-1009.486 -856.289)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M1009.5,883.5c0,3.359,4.533,6.071,10.117,6.071s10.117-2.712,10.117-6.071",
    transform: "translate(-1009.486 -847.077)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M1010.169,882c1.76,1.821,5.018,3.035,8.762,3.035s7-1.214,8.762-3.035",
    transform: "translate(-1008.8 -848.613)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M1019.5,898.852V868.5",
    transform: "translate(-999.251 -862.43)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M1009.5,898.852V868.5",
    transform: "translate(-1009.486 -862.43)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M1021.5,883.5a4.323,4.323,0,0,0,1.356,3.035c1.76,1.821,5.018,3.035,8.762,3.035s7-1.214,8.762-3.035a4.323,4.323,0,0,0,1.356-3.035",
    transform: "translate(-997.204 -847.077)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M1021.5,877.5a4.322,4.322,0,0,0,1.356,3.035c1.76,1.821,5.018,3.035,8.762,3.035s7-1.214,8.762-3.035a4.322,4.322,0,0,0,1.356-3.035",
    transform: "translate(-997.204 -853.218)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1082",
    "data-name": "Ellipse 1082",
    cx: 10.11,
    cy: 6.154,
    rx: 10.11,
    ry: 6.154,
    transform: "translate(24.324 12.015)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M1021.5,880.5a4.323,4.323,0,0,0,1.356,3.035c1.76,1.821,5.018,3.035,8.762,3.035s7-1.214,8.762-3.035a4.323,4.323,0,0,0,1.356-3.035",
    transform: "translate(-997.204 -850.147)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M1031.5,874.5v18.211",
    transform: "translate(-986.969 -856.289)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M1021.5,874.5v18.211",
    transform: "translate(-997.204 -856.289)",
    fill: "none",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnPoints);
export default __webpack_public_path__ + "static/media/Earn Points.bfe790ca574c4a340b55a413e7761de5.svg";
export { ForwardRef as ReactComponent };